// 2) Third-party library imports
import { createAction, createSlice } from '@reduxjs/toolkit';

// 3d) Utility functions
import { DynamicObject } from '../../utils/commonInterfaces';

const actionPrefix = 'conversationLine';

// Type-safe initialState!
export const initialState = {};

const conversationLineSlice = createSlice({
    name: 'conversationLine',
    initialState,
    reducers: {}
});

const { reducer } = conversationLineSlice;

// Actions
export const fetchCommunicationResourceResponseDetailsAction = createAction(
    `${actionPrefix}/fetchCommunicationResourceResponseDetailsAction`,
    function prepare(
        conversationLineId: string,
        callback: (response: DynamicObject) => void
    ) {
        return {
            payload: { conversationLineId, callback }
        };
    }
);
export const sendCommunicationResourceResponseAction = createAction(
    `${actionPrefix}/sendCommunicationResourceResponseAction`,
    function prepare(
        payload: DynamicObject,
        callback: (response: DynamicObject) => void
    ) {
        return {
            payload: { payload, callback }
        };
    }
);
export const publicAttachToResourceRequestAction = createAction(
    `${actionPrefix}/publicAttachToResourceRequestAction`,
    function prepare(
        payload: DynamicObject,
        callback: (response: DynamicObject) => void
    ) {
        return {
            payload: { payload, callback }
        };
    }
);

// Reducer
export default reducer;